import { defineElement, FC, onDidLoad, useElement } from '@atomify/hooks';
import { h } from '@atomify/jsx';
import { BPDFunctionalSvg } from '@atoms/index';

const HIGHLIGHTED_CLASS = 'header-alerts-button--highlighted';

const HeaderAlertsButton: FC = ({ element }) => {
    const alertsTotal = useElement<HTMLElement>('[js-hook-header-alerts-button-total]');

    let alertsLength: number = 0;

    onDidLoad(() => {
        handleAlerts();
    });

    function handleAlerts() {
        const alerts = [];
        alertsLength = alerts?.length || 0;

        setHighlightedClass();
        setAlertsTotal();
    }

    function setHighlightedClass() {
        if (alertsLength) {
            element.classList.add(HIGHLIGHTED_CLASS);
        } else {
            element.classList.remove(HIGHLIGHTED_CLASS);
        }
    }

    function setAlertsTotal() {
        if (!alertsTotal.current) return;

        alertsTotal.current.innerHTML = alertsLength ? `${alertsLength}` : '';
    }

    return (
        <button class="header-alerts-button__link">
            <div class="header-alerts-button__icon">
                <BPDFunctionalSvg name="icons-bell" />
            </div>

            <span class="header-alerts-button__total u-label" js-hook-header-alerts-button-total />
        </button>
    );
};

defineElement('bpd-header-alerts-button', HeaderAlertsButton);
